module.exports = __webpack_public_path__ + "static/img/model-3.54a1c1a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/model-3.gif
// module id = qVVh
// module chunks = 0